import { Injectable } from '@angular/core';
import { ElementLoaderService } from './element-loader.service';
import { ProviderService } from './provider.service';

@Injectable({
  providedIn: 'root'
})
export class FlavorService {
  private _deferredPrompt: any = null;
  private flavorSet = false;
  private document: Document | null = null;

  public set deferredPrompt(value: any) {
      this._deferredPrompt = value;
      if (!this.flavorSet || this.document == null)
        return;
      const addBtn = document.getElementById("install_mobile");
      if (addBtn == null || this.deferredPrompt == null) return;
      addBtn.style.display = "inline-block";
      addBtn.addEventListener("click", (e) => {
        addBtn.style.display = "none";
        this.deferredPrompt.prompt();
      })
  }

  public get deferredPrompt(): any {
      return this._deferredPrompt;
  }

  constructor(
    private elementLoaderService: ElementLoaderService,
    private providerService: ProviderService,
  ) { }

  setLanus(document: Document, provider: any) : void {
    this.document = document;
    document.title = "Lanús - Telemedicina";
    const link = document.querySelector("link[rel='icon']");
    if (link)
      link.setAttribute("href", "/assets/lanus/favicon.ico");
    const link16x16 = document.querySelector("link[sizes='16x16']");
    if (link16x16)
      link16x16.setAttribute("href", "/assets/lanus/logo-small-16x16.png");
    const link32x32 = document.querySelector("link[sizes='32x32']");
    if (link32x32)
      link32x32.setAttribute("href", "/assets/lanus/logo-small-32x32.png");
    const linkAppleTouch = document.querySelector("link[rel='apple-touch-icon']");
    if (linkAppleTouch)
      linkAppleTouch.setAttribute("href", "/assets/lanus/apple-touch-icon.png");
    if (provider?.id == "63d3f6cae0a97800915a804f")
      this.elementLoaderService.appendManifest(document, "/assets/lanus/app.webmanifest");
    else if (provider?.id == "63a3461dd21709009859ad29")
      this.elementLoaderService.appendManifest(document, "/assets/lanus/app.dev.webmanifest");
    this.flavorSet = true;
  }

  setFlavor(document: Document, provider: any) : void {
    if (!provider)
      return;

    if (this.providerService.isLanus(provider?.id)) {
      this.setLanus(document, provider);
    }
  }
}
